import { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import "./modalComponent.css";

interface ModalProps {
  buttonText?: string;
  buttonText2?: string;
  buttonText3?: string;
  modalTitle?: string;
  cancelButton?: string;
  saveButton?: string;
  children?: React.ReactNode;
  isVisible?: boolean; // Changed from React.ReactNode to boolean
  onClose?: () => void;
  onSave?: () => void;
  onSave2?: () => void;
  onSave3?: () => void;
  ModalbodyClass?: string;
  viewOnly?: boolean;
  disabled?: boolean;
  isLoading?: string;
  className?: string;
}

const ModalComponent: React.FC<ModalProps> = ({
  buttonText,
  className,
  buttonText2,
  buttonText3,
  ModalbodyClass,
  modalTitle,
  children,
  isVisible,
  cancelButton,
  saveButton,
  onSave2,
  onSave3,
  onClose,
  onSave,
  viewOnly,
  disabled,
  isLoading
}) => {
  return (
    <>
      <div className="custom-modal fade" id="edit_role" role="dialog">
        <Modal show={isVisible} onHide={onClose} centered className={className}>
          <Modal.Header className={className}>
            <Modal.Title>{modalTitle}</Modal.Title>
            <button className="btn-close" onClick={onClose}>
              <i className="ti ti-x"></i>
            </button>
          </Modal.Header>
          <Modal.Body className={className}>{children}</Modal.Body>
          {cancelButton && (
            <Modal.Footer className="d-flex justify-content-end modal-btn">
              <>
                <Button className="btn btn-light btn-light-red" onClick={onClose}>
                  {cancelButton}
                </Button>
                {buttonText2 &&
                  <Button className="btn btn-light btn-light-red" onClick={onSave2}>
                    {buttonText2}
                  </Button>
                }
                 {buttonText3 &&
                  <Button className="btn btn-light btn-light-red" onClick={onSave3}>
                    {buttonText3}
                  </Button>
                }

                {viewOnly ? ('') :
                  <Button
                    type="submit"
                    disabled={disabled}
                    className="btn btn-primary"
                    onClick={onSave}
                  >
                    {isLoading ? isLoading : saveButton}
                  </Button>
                }
              </>
            </Modal.Footer>
          )}
        </Modal>
      </div>
    </>
  );
};

export default ModalComponent;
